import React from 'react';
import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizReasoningTopics() {
  return (
   <>  

   <QuizSubjectTopics name="quiz" link="quiz/reasoning" type="quiz" subject="reasoning" topic="atoz" subjectName="reasoning" />
   
   </>
  );
}

export default QuizReasoningTopics;